import React, { Component } from "react";
import CreateSwagger from './modals/CreateSwagger';
import SwaggersList from './side-panel/SwaggersList';

import { Button } from 'react-bootstrap';

class SidePanel extends Component {
  state = {
    showCreateModal: false
  };

  showCreateModal = () => {
    this.setState({showCreateModal: true});
  }

  hideCreateModal = () => {
    this.setState({showCreateModal: false});
  }

  render() {
    return(
      <div className="side-bar black-bg">
        <CreateSwagger
          show={this.state.showCreateModal}
          hide={this.hideCreateModal}
          groups={this.props.groups}
          onSave={this.props.createSwagger} />

        <h2 className="swagger-title">Swaggers</h2>
        <Button
            bsStyle="success"
            onClick={this.showCreateModal}
            className="create-swagger"
        >
            New Swagger
        </Button>

        <div className="clear"></div>

        <SwaggersList swaggers={this.props.swaggers}
          groups={this.props.groups}
          loadSwagger={this.props.loadSwagger}/>
      </div>
    );
  }
}

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/swagger-view/SidePanel.js